module.exports = __webpack_public_path__ + "media/images/temp-closed-icon-d36066a5074add2ced0a740aa39d8edb.svg";